import { WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';

import { StoreModel } from '../models/model.store';

@Injectable()
export class SubcontractorStoreService {
  _subcontractor$ = new BehaviorSubject<StoreModel>(null);

  constructor(
    private templateProjectSubcontractorService: WalkAndPunchApiClient,
    private loginService: LoginService
  ) {}

  reloadSubcontractor() {
    const projectTemplate = this.loginService.projectTemplate;
    this.loadSubcontractors()
      .pipe(take(1))
      .subscribe((data) => {
        this.subcontractor = { data, projectId: projectTemplate.project.id, templateId: projectTemplate.template.id };
      });
  }

  loadSubcontractors() {
    const projectTemplate = this.loginService.projectTemplate;
    return this.templateProjectSubcontractorService.v1TemplateProjectSubcontractGetProjectTemplateSubcontractsGET(projectTemplate.template.id);
  }

  get subcontractor() {
    return this._subcontractor$.value;
  }

  set subcontractor(data: StoreModel) {
    this._subcontractor$.next(data);
  }

  get subcontractor$() {
    return this._subcontractor$;
  }
}
